import { toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createVNode as _createVNode, vShow as _vShow, withDirectives as _withDirectives, withModifiers as _withModifiers, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, TransitionGroup as _TransitionGroup, withCtx as _withCtx, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-4ed00d42")

_pushScopeId("data-v-4ed00d42")
const _hoisted_1 = { class: "d-good-road-panel-root" }
const _hoisted_2 = { class: "panel-wrap" }
const _hoisted_3 = { class: "panel" }
const _hoisted_4 = { class: "tab" }
const _hoisted_5 = {
  key: 0,
  class: "tab-count"
}
const _hoisted_6 = {
  key: 0,
  class: "tab-count"
}
const _hoisted_7 = /*#__PURE__*/_createVNode("svg", {
  class: "sort-icon",
  viewBox: "0 0 18 14",
  "aria-hidden": "true"
}, [
  /*#__PURE__*/_createVNode("path", { d: "M1 3.5h11.5M9.5 1 13 3.5 9.5 6" }),
  /*#__PURE__*/_createVNode("path", { d: "M17 10.5H5.5M8.5 8 5 10.5 8.5 13" })
], -1)
const _hoisted_8 = { class: "sort-label" }
const _hoisted_9 = /*#__PURE__*/_createVNode("path", { d: "M1 1.5 6 6.5 11 1.5" }, null, -1)
const _hoisted_10 = { class: "sort-menu" }
const _hoisted_11 = { class: "list-wrap" }
const _hoisted_12 = { class: "list-scroll" }
const _hoisted_13 = {
  key: "good-road-empty",
  class: "empty"
}
const _hoisted_14 = /*#__PURE__*/_createVNode("span", { class: "icon icon-close" }, null, -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_d_good_road_item = _resolveComponent("d-good-road-item")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode("div", _hoisted_3, [
        _createVNode("div", _hoisted_4, [
          _createVNode("div", {
            class: ["tab-item", { active: _ctx.selectedIndex === 'G002' }],
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.changeIndex('G002')))
          }, [
            _createTextVNode(_toDisplayString(_ctx.iN('common.baccarat')) + " ", 1),
            (_ctx.baccaratGoodRoadCount > 0)
              ? (_openBlock(), _createBlock("span", _hoisted_5, _toDisplayString(_ctx.baccaratGoodRoadCount), 1))
              : _createCommentVNode("", true)
          ], 2),
          _createVNode("div", {
            class: ["tab-item", { active: _ctx.selectedIndex === 'G003' }],
            onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.changeIndex('G003')))
          }, [
            _createTextVNode(_toDisplayString(_ctx.iN('common.dragontiger')) + " ", 1),
            (_ctx.dragonTigerGoodRoadCount > 0)
              ? (_openBlock(), _createBlock("span", _hoisted_6, _toDisplayString(_ctx.dragonTigerGoodRoadCount), 1))
              : _createCommentVNode("", true)
          ], 2),
          _createVNode("div", {
            class: "sort-filter",
            onClick: _cache[6] || (_cache[6] = _withModifiers(() => {}, ["stop"]))
          }, [
            _createVNode("button", {
              type: "button",
              class: "sort-trigger",
              onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.toggleSortMenu && _ctx.toggleSortMenu(...args)))
            }, [
              _hoisted_7,
              _createVNode("span", _hoisted_8, _toDisplayString(_ctx.sortLabel), 1),
              (_openBlock(), _createBlock("svg", {
                class: ["chevron", { open: _ctx.showSortMenu }],
                viewBox: "0 0 12 8",
                "aria-hidden": "true"
              }, [
                _hoisted_9
              ], 2))
            ]),
            _withDirectives(_createVNode("ul", _hoisted_10, [
              _createVNode("li", {
                class: { active: _ctx.sortMode === 'goodRoad' },
                onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.setSortMode('goodRoad')))
              }, _toDisplayString(_ctx.iN('common.goodroadsort')), 3),
              _createVNode("li", {
                class: { active: _ctx.sortMode === 'table' },
                onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.setSortMode('table')))
              }, _toDisplayString(_ctx.iN('common.tablesort')), 3)
            ], 512), [
              [_vShow, _ctx.showSortMenu]
            ])
          ])
        ]),
        _createVNode("div", _hoisted_11, [
          _createVNode("div", _hoisted_12, [
            _createVNode(_TransitionGroup, {
              name: "good-road-list",
              tag: "div",
              class: "list"
            }, {
              default: _withId(() => [
                (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.listData, (entry) => {
                  return (_openBlock(), _createBlock("div", {
                    key: entry.table.id,
                    class: "list-item-wrap"
                  }, [
                    _createVNode(_component_d_good_road_item, {
                      class: "list-item",
                      entry: entry,
                      chipValue: _ctx.chipValue,
                      pinned: _ctx.pinnedTableIds.includes(entry.table.id),
                      onOnBetSuccess: _ctx.onItemBetSuccess,
                      onTogglePin: ($event: any) => (_ctx.togglePin(entry.table.id)),
                      onEnterDesk: ($event: any) => (_ctx.clickedItem(entry.table))
                    }, null, 8, ["entry", "chipValue", "pinned", "onOnBetSuccess", "onTogglePin", "onEnterDesk"])
                  ]))
                }), 128)),
                (!_ctx.listData.length)
                  ? (_openBlock(), _createBlock("div", _hoisted_13, " 暂无桌台 "))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            })
          ])
        ])
      ]),
      _createVNode("button", {
        class: "close-btn",
        type: "button",
        onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.hideMe && _ctx.hideMe(...args)))
      }, [
        _hoisted_14
      ])
    ])
  ]))
})